import { PROVENANCE_LEGEND } from "../../lib/provenance";

// Per-element provenance marks — ONE visual language, reusing the existing
// confidence-dot vocabulary. Verified (green dot): mechanically checked
// against the source. AI chip (muted): an AI judgment that decorates but is
// never authoritative. The tooltip carries the shared legend.
export function VerifiedMark({ what }: { what: string }) {
  return (
    <span
      className="confidence-dot confidence-green prov-mark"
      role="img"
      aria-label={`${what} verified`}
      title={`${what} — mechanically verified against the source document.\n\n${PROVENANCE_LEGEND}`}
    />
  );
}

export function AiMark({ what }: { what: string }) {
  return (
    <span
      className="prov-ai-chip"
      role="img"
      aria-label={`${what}: AI-generated`}
      title={`${what} — AI assistance, not a verified claim.\n\n${PROVENANCE_LEGEND}`}
    >
      AI
    </span>
  );
}

// Date gradation — carried over, not flattened: a fact date that differs
// from its record's date was verified against the quoted text
// (deterministic); one equal to the record date is the record-date default.
export function DateMark({
  factDate,
  recordDate,
}: {
  factDate: string | null;
  recordDate: string | null | undefined;
}) {
  if (!factDate) return null;
  const fromQuote = !!recordDate && factDate.slice(0, 10) !== recordDate.slice(0, 10);
  return (
    <span
      className={`confidence-dot confidence-${fromQuote ? "green" : "amber"} prov-mark`}
      role="img"
      aria-label={fromQuote ? "Date verified in quoted text" : "Record date (default)"}
      title={
        fromQuote
          ? "Event date verified in the quoted text."
          : "No distinct event date in the quote — showing the record's own date."
      }
    />
  );
}
